import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserIdentityService } from '@shared/core/user-identity.service';
import { AttributeEditor } from '@shared/model/attribute-editor';
import { Resources } from '@shared/model/permissions';
import { AttributeEditorService } from '@shared/services/attribute-editor.service';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-attribute-editors',
  imports: [CommonModule, SharedModule],
  templateUrl: './attribute-editors.component.html',
  styleUrl: './attribute-editors.component.scss'
})
export class AttributeEditorsComponent implements OnInit {
  myEditors!: AttributeEditor[];
  hasEditorPermission: boolean = false;

  constructor(
    private attributeEditorService: AttributeEditorService,
    private userIdentityService: UserIdentityService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getMyEditors();
    this.hasEditorPermission = this.hasPermission(Resources.AttributeEditWindows);
  }

  getMyEditors() {
    this.attributeEditorService.getMyEditors()
      .subscribe(editors => {
        this.myEditors = editors;
      });
  }

  gotoEditor(editorId: string | number) {
    this.router.navigate(['/inventory/attributeeditor', editorId, 'null']);
  }

  gotoEditorSettings() {
    this.router.navigate(['/housekeeping/attributeeditwindows']);
  }

  hasPermission(resource: Resources) {
    const resourceItem = this.userIdentityService.currentPermissionValue?.find(a => a.resource == resource);
    return !!resourceItem;
  }

}
